import { Link } from 'gatsby';
import { OutboundLink } from 'gatsby-plugin-gtag';
import { EuiSpacer } from '@elastic/eui';
import NavButtons from 'components/Indoor_Cameras/IN-8815_QFHD/NavButtons';
import CompareIndoor from 'components/Products/Compare/CompareIndoorFlyout';
import SmartCards from 'components/Products/Flyouts/Cards/8815Cards';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  OutboundLink,
  EuiSpacer,
  NavButtons,
  CompareIndoor,
  SmartCards,
  BreadCrumbs,
  SEOHelmet,
  React
};